<script setup>
import { watch, onMounted } from 'vue'
import { useLanguage } from '@/composables/useLanguage'
import { LANGUAGES, DEFAULT_LANGUAGE } from '@/constants/languages'

const { currentLanguage } = useLanguage()

const updateHtmlLang = (lang) => {
  const config = LANGUAGES[lang] || LANGUAGES[DEFAULT_LANGUAGE]
  document.documentElement.lang = config.locale
}

onMounted(() => {
  updateHtmlLang(currentLanguage.value)
})

watch(currentLanguage, (newLang) => {
  updateHtmlLang(newLang)
})
</script>

<template>
  <!-- Componente invisível - apenas atualiza o atributo lang -->
</template>
